import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { UiButton } from '@/components/ui/Button';
import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { useOnboarding } from '@/pages/Onboarding/context';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../../OwnAI/components/Title';
import { LayoutDataType } from '../../types';

import {
  ContentWrapperStyles,
  OverlayStyles,
  PageStyles,
} from './SendPhoto.styles';

export const ScreenSendPhoto: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'SendPhoto',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();

  const handleSelect = (value: boolean) => {
    form.setValue('send_photos', value);
    userService.createOrUpdate({ onboarding_data: { send_photos: value } });
    wizard.nextStep();
  };

  return (
    <PageStyles
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-ons/send-photos/bg.png`}
    >
      <IonContent>
        <OverlayStyles />
        <ContentWrapperStyles>
          <OwnAiTitle>Would you like to receive NSFW photos?</OwnAiTitle>
          <UiButton
            size="large"
            onClick={() => handleSelect(true)}
            expand={'full'}
            round={'md'}
          >
            Yes
          </UiButton>
          <UiButton
            size="large"
            onClick={() => handleSelect(false)}
            expand={'full'}
            round={'md'}
            color={'transparent'}
          >
            No
          </UiButton>
        </ContentWrapperStyles>
      </IonContent>
    </PageStyles>
  );
};
